<div editable-content *editableData="let edit from model" (valueChanged)="valueChanged.emit($event)">
	<display-content>
		<h3>{{ label }}</h3>
		@if (isHtmlContent) {
			<div [isHtmlContent]="true" [formattedContent]="displayValue"></div><ng-content />
		}
		@else if (inputType === inputTypeEnum.DateTime && getDateTime()) {
			{{ getDateTime()?.date | customDate }}<ng-content />
		}
		@else {
			{{ displayValue }}<ng-content />
		}
	</display-content>
	<edit-content>
		@if (inputType == inputTypeEnum.Select) {
			<custom-select [label]="label"
						   [(value)]="edit.value"
						   [selectList]="selectList"
						   [placeholder]="placeholder" />
		}

		@if (inputType != inputTypeEnum.Date && inputType != inputTypeEnum.Select && inputType != inputTypeEnum.DateTime) {
			<custom-input [label]="label"
						  [inputType]="inputType"
						  [(value)]="edit.value"
						  [placeholder]="placeholder"
						  [ignoreFormValidation]="ignoreFormValidation" />
		}

		@if (inputType == inputTypeEnum.DateTime) {
			<date-time-input [label]="label ?? placeholder"
							 [(value)]="edit.value"
							 [maxDate]="maxDate"
							 [keepFocus]="true"
							 [inline]="true" />
		}
	</edit-content>
</div>
